module.exports = __webpack_public_path__ + "static/shop-and-earn-cashback-mobile-f4601a7f4004ccc3e23b1ca41dfe0f4d.png";